import { render, staticRenderFns } from "./ModalCadastroDisciplinaItinerarioFormativo.vue?vue&type=template&id=70edab8e"
import script from "./ModalCadastroDisciplinaItinerarioFormativo.vue?vue&type=script&lang=js"
export * from "./ModalCadastroDisciplinaItinerarioFormativo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports